import React, { useEffect, useState } from "react";
import { SupportedLanguage } from "@src/types/orgSettings";
import Modal from "@components/atoms/Modal";
import RadioButton from "@components/atoms/RadioButton";
import { Button, Spacer } from "@components/atoms";
import { ButtonCategory, ButtonType } from "@components/atoms/Button/types";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { useTranslation } from "react-i18next";
import { ScrollView } from "react-native";

type LanguageModalProps = {
  isOpen: boolean;
  onClose: () => void;
  languages: SupportedLanguage[];
  selectedLanguage: SupportedLanguage | null;
  changeLanguage: (lan: string | undefined) => void;
};

const LanguageModal = ({
  isOpen,
  onClose,
  languages,
  selectedLanguage,
  changeLanguage,
}: LanguageModalProps) => {
  const [selectedLang, setSelectedLang] = useState(selectedLanguage);
  const theme = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    setSelectedLang(selectedLanguage);
  }, [selectedLanguage]);

  const handleLanguageChange = (language: any) => {
    setSelectedLang(language);
  };

  const handleDoneClick = () => {
    changeLanguage(selectedLang?.code);
    onClose();
  };
  return (
    <Modal
      headerTitle={t("global.text.changeLanguage")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={16}
      paddingRight={16}
      paddingBottom={40}
      paddingTop={16}
    >
      <ScrollView keyboardShouldPersistTaps={"always"}>
        {languages &&
          languages.length &&
          languages.map((language, i) => {
            return (
              <RadioButton
                key={i}
                label={language.long_name}
                labelColor={
                  language.code === selectedLanguage?.code
                    ? theme["core-05"]
                    : theme["core-06"]
                }
                checked={language.code === selectedLang?.code}
                onPress={() => handleLanguageChange(language)}
              />
            );
          })}
      </ScrollView>
      <Spacer size={SpaceType.Big} />
      <Button
        category={ButtonCategory.default}
        type={ButtonType.primary}
        title={t("global.text.done")}
        onPress={handleDoneClick}
      />
    </Modal>
  );
};

export default LanguageModal;
